import { render } from "./AssessmentDetailSkeleton.vue?vue&type=template&id=36b2a318&scoped=true"
import script from "./AssessmentDetailSkeleton.vue?vue&type=script&lang=js"
export * from "./AssessmentDetailSkeleton.vue?vue&type=script&lang=js"

import "./AssessmentDetailSkeleton.vue?vue&type=style&index=0&id=36b2a318&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36b2a318"]])

export default __exports__